import { createAsyncActionType } from '.';

export const CATEGORY_MEDIA_GET = createAsyncActionType(
  'utils',
  'CATEGORY_MEDIA_GET'
);

export const CATEGORY_MEDIA_RESET = '@@utils/CATEGORY_MEDIA_RESET';

export const CATEGORY_MEDIA_UPLOAD = createAsyncActionType(
  'utils',
  'CATEGORY_MEDIA_UPLOAD'
);
